import React from 'react';

import {
  CSRF_TOKEN
} from '../lib/helpers';

import {useModal} from '../hooks';
import Modal from './Modal';

const UserCoinUpdateModal = ({
  toolLabel,
  toolClass,
  endPoint
}) => {
  const [modal, modalSet] = useModal({ keyboardBindings: true })
  return (
    <React.Fragment>
      <a className={toolClass} onClick={() => modalSet(true)}>
        {toolLabel}
      </a>
      <Modal isActive={modal} onToggleModal={() => modalSet(false)} reset>
        <div className='EditModal'>
          <h3 className='Modal__h3'>{toolLabel}</h3>
          <form method="post" action={endPoint} className='EditModal__form'>
            <input type="hidden" name="authenticity_token" value={CSRF_TOKEN} />
            <input
              type='number'
              min='1'
              max='20000'
              className='Input'
              name='amount'
              placeholder='amount of coins'
              defaultValue={50}
              required
            />

            <div className='EditModal__form__buttons'>
              <button type="button"
                className='Button Button--gray-light'
                onClick={() => modalSet(false)}
              >
                Cancel
              </button>

              <button type="submit" className='Button Button--green'>
                Submit
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default UserCoinUpdateModal
